import React from 'react';

const PublicSectionContainer = props => {
    const { children } = props;

    return <main className='flex-grow flex-column'>{children}</main>;
};

export default PublicSectionContainer;
